import { IconTemplate } from '@components/Icon/IconTemplate';
import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    display: flex;
    gap: ${rem(30)};
    flex-wrap: wrap;
    margin: ${rem(20)} 0 ${rem(35)} 0;
    justify-content: center;

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: ${rem(10)};
    padding: ${rem(40)} ${rem(30)};
    border-radius: ${rem(16)};
    border: 1px solid ${({ theme }) => theme.colors.border};

    @media (min-width: ${breakpoints.sm}px) {
        width: 23%;
        margin-bottom: ${rem(45)};
    }
`;

export const SectionIcon = styled(IconTemplate)`
    display: block;
    margin-bottom: ${rem(20)};

    svg {
        width: ${rem(40)};
        height: ${rem(40)};
    }

    &.board,
    &.feedback {
        svg {
            width: ${rem(50)};
            height: ${rem(50)};
            margin-top: ${rem(-10)};
        }
    }
`;

export const SectionLabel = styled.span`
    color: ${({ theme }) => theme.colors.grey};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    line-height: ${rem(30)};
`;
